import React, { useCallback, useEffect, useState } from 'react'
import Header from 'components/Header'
import { Col, Row } from 'react-bootstrap'
import { reqCalculateCartOrderPrice } from 'cart/CartRequests'
import { IOrderPrice } from 'order_components/IOrder'
import CartProductsPhase from './CartProductsPhase'
import MySpinner from 'components/MySpinner'
import RequestInfoPhase from './RequestInfoPhase'
import OrderPricePanel from './OrderPricePanel'
import { useAuth } from 'auth/AuthProvider'
import BlueButton from 'components/inputs/BlueButton'
import { PAGE_URL_PROFILE } from 'SiteURLs'
import { useCart } from 'cart/CartProvider'

type TCartRequestPhase = 'show_cart_products' | 'request_phase'

const CartPage: React.FC = () => {
  const auth = useAuth()
  const [cart] = useCart()
  const [phase, setPhase] = useState<TCartRequestPhase>('show_cart_products')
  const [orderPrice, setOrderPrice] = useState<IOrderPrice>({
    total_price: 0,
    delivery_price: 0,
  })
  const [noProducts, setNoProducts] = useState(false)
  const [error, setError] = useState<string>('')

  useEffect(() => {
    setError('')
    let mount = true

    if (cart) {
      reqCalculateCartOrderPrice((orderPrice) => {
        if (mount) {
          setOrderPrice(orderPrice)
        }
      })

      setNoProducts(false)
      for (let product of cart.products) {
        if (product.left_quantity === 0) {
          setNoProducts(true)
          break
        }
      }
    }

    return () => {
      mount = false
    }
  }, [cart])

  const toRequestPhase = useCallback(() => {
    setPhase('request_phase')
  }, [])

  const toCartProducts = useCallback(() => {
    setPhase('show_cart_products')
  }, [])

  const updatePrice = useCallback(() => {
    reqCalculateCartOrderPrice((orderPrice) => {
      setOrderPrice(orderPrice)
    })
  }, [])

  return (
    <>
      <Row>
        <Col xs={12} className='pt-header'>
          <Header>Корзина</Header>
        </Col>
      </Row>
      <Row>
        {!cart ? (
          <Col xs={12} lg={8} style={{ paddingTop: '50px' }}>
            <MySpinner />
          </Col>
        ) : auth.user && !auth.user.name ? (
          <Col xs={12}>
            <h5>Пожалуйста, завершите регистрацию и заполните имя.</h5>
            <div className='mb-2' />
            <BlueButton href={'#/' + PAGE_URL_PROFILE}>Перейти к профилю</BlueButton>
          </Col>
        ) : (
          <>
            <Col xs={12} lg={8}>
              <>
                {phase === 'show_cart_products' ? (
                  <CartProductsPhase toNextPhase={toRequestPhase} disabled={noProducts} />
                ) : (
                  <RequestInfoPhase
                    orderPrice={orderPrice}
                    noProducts={noProducts}
                    onGoToPrevScreen={toCartProducts}
                    onChange={updatePrice}
                    onError={setError}
                  />
                )}
                {(error || noProducts) && (
                  <Row className='mt-2'>
                    <div
                      className='h3-rem mb-2 d-flex justify-content-center'
                      style={{ color: 'var(--color-red)' }}
                    >
                      {noProducts
                        ? 'Один или несколько товаров из списка отсутствует в выбранном офисе'
                        : error}
                    </div>
                  </Row>
                )}
              </>
            </Col>
            <Col xs={12} lg={4}>
              <OrderPricePanel
                cart={cart}
                orderPrice={orderPrice}
                showProducts={phase !== 'show_cart_products'}
              />
            </Col>
          </>
        )}
      </Row>
    </>
  )
}
export default CartPage
